<template>
  <div>
    <h4 class="mb-4 bold text-overflow">
      Ban hành văn bản "{{ `${this.$route.query.name}` }}"
    </h4>
    <!-- Start Step -->
    <b-row class="mb-4">
      <b-col md="4" class="pl-0">
        <el-steps :active="activeProcess" finish-status="success">
          <el-step title="Chọn con dấu"></el-step>
          <el-step title="Ban hành"></el-step>
        </el-steps>
      </b-col>
    </b-row>
    <!-- End Step -->
    <div v-if="activeProcess == 0">
      <!-- Start Preview File -->
      <div class="body-pdf">
        <div
          class="pdf-container"
          :style="
            drawerVisible ? 'right: 0%; width: 75%' : 'right: 0%; width: 98%'
          "
        >
          <div class="dropzone">
            <div class="pdf-content" id="pdf-content">
              <div
                class="canvas text-center pdfViewer singlePageView nopadding"
              >
                <Draggable
                  v-if="!changedSignImage"
                  @endDragSign="endDragSign"
                  :imageSignId="imgSignId"
                  :pageNum="pageNum"
                  :positionSign="dataObject.position"
                  :currentPage="pageNum"
                  :from="imgSignId ? 'DrafDocument' : ''"
                  @removeSignImage="fn_deleteSignImage"
                />
                <ViewPdf
                  @changePageNum="changePageNum"
                  @pdfSize="handlePdfSize"
                  :fileId="fileId"
                  :currentPage="pageNum"
                  :pageSign="pageSign"
                />
              </div>
            </div>
            <div class="paging ml-26 text-center">
              <p>
                Trang
                <el-input-number
                  class="current-page ml-1 mr-1"
                  :controls="false"
                  v-model="pageNum"
                  @change="changePage(pageNum)"
                  :min="1"
                  :max="numPages"
                ></el-input-number>
                / {{ numPages }}
              </p>
            </div>
          </div>
        </div>
        <div>
          <!-- Start Drawer -->
          <div class="drawer-container">
            <!-- Start full drawer -->
            <div v-if="drawerVisible" class="drawer">
              <div class="drawer__header d-flex align-items-center">
                <i
                  class="icon el-icon-d-arrow-right mt-1 mr-2"
                  @click="fn_toggleDrawer"
                ></i>
                <p class="drawer__header-title">Thanh công cụ</p>
              </div>

              <div class="drawer__box">
                <!-- Start main Sign images -->
                <p class="drawer__box-title">Con dấu khác</p>
                <div class="drawer__box-content">
                  <p
                    v-if="fileUploadOption.FileChuKy.listImageSigns.length == 0"
                    class="empty__tab-text text-center"
                  >
                    Không có dữ liệu.
                  </p>
                  <!-- Start list Sign image -->
                  <div v-else class="list-sign-image" id="selectorContainer">
                    <el-radio-group
                      v-model="imgSignId"
                      class="radio-group"
                      @change="changeSignImage(imgSignId)"
                    >
                      <el-radio
                        v-for="(item, index) in fileUploadOption.FileChuKy
                          .listImageSigns"
                        :key="index"
                        :label="item.sign_image_id"
                      >
                        <div class="border-image">
                          <el-image :src="item.url" fit="cover"></el-image>
                        </div>
                      </el-radio>
                    </el-radio-group>
                    <!-- <div class="border-image">
                      <el-upload
                        :auto-upload="false"
                        drag
                        action
                        multiple
                        :accept="fileUploadOption.FileChuKy.accept"
                        :on-change="fn_uploadSign"
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                          Kéo vào đây <br />
                          hoặc <em>click để upload</em>
                        </div>
                      </el-upload>
                    </div> -->
                  </div>
                  <!-- End list Sign images -->
                </div>
              </div>
              <!-- End main Sign images -->
              <!-- Start Other Sign images -->
              <div class="drawer__box">
                <p class="drawer__box-title">Con dấu tổ chức</p>
                <div class="drawer__box-content">
                  <p
                    v-if="mData.dataDefault.listCompanySign == 0"
                    class="empty__tab-text text-center"
                  >
                    Không có dữ liệu.
                  </p>
                  <!-- Start list Sign image -->
                  <div v-else class="list-sign-image">
                    <el-radio-group
                      v-model="imgSignId"
                      class="radio-group"
                      @change="changeSignImage(imgSignId)"
                    >
                      <el-radio
                        v-for="(item, index) in mData.dataDefault
                          .listCompanySign"
                        :key="index"
                        :label="item.sign_image_id"
                      >
                        <div class="border-image">
                          <el-image :src="item.url" fit="cover"></el-image>
                        </div>
                      </el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
              <!-- End Other Sign images -->
            </div>
            <!-- End full drawer -->
            <!-- Start collapse drawer -->
            <div class="drawer-collapse" v-else>
              <div>
                <div
                  class="drawer__header d-flex align-items-center"
                  style="cursor: pointer"
                  @click="fn_toggleDrawer"
                >
                  <i class="icon el-icon-d-arrow-left mb-1"></i>
                  <p class="drawer__header-title">Thanh công cụ</p>
                </div>
              </div>
            </div>
            <!-- End collapse drawer -->
          </div>
          <!-- End Drawer -->
        </div>
      </div>
      <!-- Start Manipulate button -->
      <div class="text-right mt-3 pb-3 pr-0">
        <el-button class="btn__doc btn__doc-back" @click="fn_goBackPrevious"
          >Quay lại</el-button
        >
        <el-button
          v-if="viewMode == 'choose-seal'"
          :disabled="!imgSignId"
          class="btn__doc btn__doc-transfer"
          @click="fn_submitForm('next-to-promulgate')"
          >Tiếp theo</el-button
        >
      </div>
      <!-- End Manipulate button -->
      <!-- End Preview File -->
    </div>
    <div v-if="activeProcess == 1">
      <b-row class="mb-3">
        <b-col md="6" class="left-side p-0">
          <div class="section-1">
            <h6 class="bold title__section-1">
              1. Chọn cá nhân, đơn vị hoặc nhóm bên dưới để ban hành văn bản
            </h6>
          </div>
          <div class="w-100 mr-3 mb-3">
            <el-input
              type="text"
              v-model="textFilter"
              placeholder="Tìm kiếm người dùng, đơn vị, nhóm (Enter để tìm kiếm)"
              prefix-icon="fal fa-search"
              @keyup.enter.native="fn_getListDataByTab(true)"
            ></el-input>
          </div>
          <!-- Start Tab -->
          <el-tabs
            type="border-card"
            v-model="tabName"
            @tab-click="fn_handleClickTab"
          >
            <!-- Start Tab CaNhan -->
            <el-tab-pane name="CaNhan">
              <span slot="label">
                <div class="d-flex justify-content-center align-items-center">
                  <i class="icon icon24-Profile mr-2"></i>
                  <span>Chọn cá nhân</span>
                </div>
              </span>
              <div
                v-if="listPeopleFilter.length == 0"
                class="text-center center-block"
              >
                <h5 class="empty__tab-text">Không có dữ liệu.</h5>
              </div>
              <!-- Start Tab Body -->
              <el-card
                shadow="hover"
                v-for="emp in listPeopleFilter"
                :key="emp.id"
                :class="{
                  'card-item': true,
                  checked: emp.value,
                }"
              >
                <b-form-checkbox
                  :data-id="emp.id"
                  v-model="emp.value"
                  @change="fn_toggleTag(emp)"
                >
                  <el-avatar
                    :src="emp.avt ? emp.avt : 'img/Vector-person.png'"
                    class="ml-2 mr-2"
                  ></el-avatar>
                  <div>
                    <div class="d-flex align-items-center">
                      <p class="bold mb-1 text-overflow-280">
                        {{ emp.administrative_info.name.full_name }}
                      </p>
                      <div
                        class="ml-2 d-flex align-items-center urgency urgent"
                        v-if="emp.is_transfered"
                      >
                        <i class="icon isax-sms-tracking c-white mr-1"></i>
                        <p class="c-white">Đã nhận</p>
                      </div>
                    </div>
                    <p>
                      {{ emp.employee_no }} •
                      {{
                        emp.administrative_info.phone_number
                          ? emp.administrative_info.phone_number
                          : "**** *** ***"
                      }}
                      {{ emp.position_name ? "• " + emp.position_name : "" }}
                    </p>
                  </div>
                </b-form-checkbox>
              </el-card>
              <!-- Start Tab Body -->
            </el-tab-pane>
            <!-- End Tab CaNhan -->

            <!-- Start Tab CaNhan -->
            <el-tab-pane name="DonVi">
              <span slot="label">
                <div class="d-flex justify-content-center align-items-center">
                  <i class="icon icon24-Tree mr-2"></i>
                  <span>Chọn đơn vị</span>
                </div>
              </span>
              <div
                v-if="
                  !mData.dataDefault.listOrganizationModelTree ||
                  (mData.dataDefault.listOrganizationModelTree &&
                    mData.dataDefault.listOrganizationModelTree.length == 0)
                "
                class="text-center center-block"
              >
                <h5 class="empty__tab-text">Không có dữ liệu.</h5>
              </div>
              <el-tree
                :data="mData.dataDefault.listOrganizationModelTree"
                default-expand-all
                node-key="id"
                ref="organizationModelTree"
                :props="defaultProps"
                :filter-node-method="fn_filterNode"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <div class="d-flex align-items-center">
                    <p v-if="!data.type">{{ data.label }}</p>
                    <el-card
                      shadow="hover"
                      :class="{
                        'card-item': true,
                        checked: node.checked,
                        'pointer-not-allow': data.not_change,
                      }"
                    >
                      <b-form-checkbox
                        v-if="data.type == 'employee'"
                        :data-id="data.id"
                        v-model="node.checked"
                        @change="
                          fn_checkManipulately(data.id, node.checked, false)
                        "
                        :disabled="node.not_change"
                        :class="{
                          'pointer-not-allow': node.not_change,
                        }"
                      >
                        <el-avatar
                          :src="data.avt ? data.avt : 'img/Vector-person.png'"
                          class="ml-2 mr-2"
                        ></el-avatar>
                        <div>
                          <div class="d-flex align-items-center">
                            <p class="bold mb-1 text-overflow-380">
                              {{ data.label }}
                            </p>
                            <div
                              class="
                                ml-2
                                d-flex
                                align-items-center
                                urgency
                                urgent
                              "
                              v-if="data.is_transfered"
                            >
                              <i
                                class="icon isax-sms-tracking c-white mr-1"
                              ></i>
                              <p class="c-white">Đã nhận</p>
                            </div>
                          </div>
                          <p>
                            <span
                              class="span__block-overflow"
                              :title="data.employee_no"
                              >{{ data.employee_no }}</span
                            >
                            •
                            {{
                              data.phone_number
                                ? data.phone_number
                                : "**** *** ***"
                            }}
                            {{
                              data.position_name
                                ? "• " + data.position_name
                                : ""
                            }}
                          </p>
                        </div>
                      </b-form-checkbox>
                    </el-card>
                  </div>
                </span>
              </el-tree>
            </el-tab-pane>
            <!-- End Tab CaNhan -->

            <!-- Start Tab Nhom -->
            <el-tab-pane name="Nhom">
              <span slot="label">
                <div class="d-flex justify-content-center align-items-center">
                  <i class="icon icon24-Group mr-2"></i>
                  <span>Chọn nhóm</span>
                </div>
              </span>
              <div
                v-if="
                  !mData.dataDefault.listDocumentBusiness ||
                  (mData.dataDefault.listDocumentBusiness &&
                    mData.dataDefault.listDocumentBusiness.length == 0)
                "
                class="text-center center-block"
              >
                <h5 class="empty__tab-text">Không có dữ liệu.</h5>
              </div>
              <el-tree
                :data="mData.dataDefault.listDocumentBusiness"
                default-expand-all
                node-key="id"
                ref="businessTree"
                :props="defaultProps"
                :filter-node-method="fn_filterNode"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <div class="d-flex align-items-center">
                    <p v-if="!data.type">{{ data.label }}</p>
                    <el-card
                      shadow="hover"
                      :class="{
                        'card-item': true,
                        checked: node.checked,
                        'pointer-not-allow': data.not_change,
                      }"
                    >
                      <b-form-checkbox
                        v-if="data.type == 'employee'"
                        :data-id="data.id"
                        v-model="node.checked"
                        @change="
                          fn_checkManipulately(
                            data.id,
                            node.checked,
                            false,
                            node,
                            data
                          )
                        "
                        :disabled="node.not_change"
                        :class="{
                          'pointer-not-allow': node.not_change,
                        }"
                      >
                        <el-avatar
                          :src="data.avt ? data.avt : 'img/Vector-person.png'"
                          class="ml-2 mr-2"
                        ></el-avatar>
                        <div>
                          <div class="d-flex align-items-center">
                            <p class="bold mb-1 text-overflow-380">
                              {{ data.label }}
                            </p>
                            <div
                              class="
                                ml-2
                                d-flex
                                align-items-center
                                urgency
                                urgent
                              "
                              v-if="data.is_transfered"
                            >
                              <i
                                class="icon isax-sms-tracking c-white mr-1"
                              ></i>
                              <p class="c-white">Đã nhận</p>
                            </div>
                          </div>
                          <p>
                            <span
                              class="span__block-overflow"
                              :title="data.employee_no"
                              >{{ data.employee_no }}</span
                            >
                            {{
                              data.phone_number
                                ? "• " + data.phone_number
                                : "• " + "**** *** ***"
                            }}
                            {{
                              data.position_name
                                ? "• " + data.position_name
                                : ""
                            }}
                          </p>
                        </div>
                      </b-form-checkbox>
                    </el-card>
                  </div>
                </span>
              </el-tree>
            </el-tab-pane>
            <!-- End Tab Nhom -->

            <!-- Start Tab GanDay -->
            <el-tab-pane name="GanDay">
              <span slot="label">
                <div class="d-flex justify-content-center align-items-center">
                  <i class="icon isax-clock mr-2"></i>
                  <span>Chọn gần đây</span>
                </div>
              </span>
              <div
                v-if="listNearestHistory.length == 0"
                class="text-center center-block"
              >
                <h5 class="empty__tab-text">Không có dữ liệu.</h5>
              </div>
              <!-- Start Tab Body -->
              <el-card
                shadow="hover"
                v-for="emp in listNearestHistory"
                :key="emp.id"
                :class="{
                  'card-item': true,
                  checked: emp.value,
                }"
              >
                <b-form-checkbox
                  :data-id="emp.id"
                  v-model="emp.value"
                  @change="fn_toggleTag(emp)"
                  :disabled="emp.not_change"
                >
                  <el-avatar
                    :src="emp.avt ? emp.avt : 'img/Vector-person.png'"
                    class="ml-2 mr-2"
                  ></el-avatar>
                  <div>
                    <p class="bold mb-1 text-overflow-380">
                      {{ emp.administrative_info.name.full_name }}
                    </p>
                    <p>
                      {{ emp.employee_no }} •
                      {{
                        emp.administrative_info.phone_number
                          ? emp.administrative_info.phone_number
                          : "**** *** ***"
                      }}
                      {{ emp.position_name ? "• " + emp.position_name : "" }}
                    </p>
                  </div>
                </b-form-checkbox>
              </el-card>
            </el-tab-pane>
            <!-- End Tab GanDay -->
          </el-tabs>
          <!-- End Tab -->
        </b-col>

        <b-col md="6" class="pr-0 right-side">
          <div class="section-2">
            <h6 class="bold">2. Nhập nội dung ban hành</h6>
            <div class="d-flex justify-content-end align-items-center issue-at">
              <h6 class="bold issue-at--text" style="width: 160px">
                Nơi ban hành
              </h6>
              <el-select v-model="mData.dataForm.department_id" placeholder="">
                <el-option
                  v-for="item in listDepaterments"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <el-input
            type="textarea"
            v-model="contentTransfer"
            placeholder="Nhập nội dung"
            clearable
            show-word-limit
            maxlength="2000"
            @input="forceUpdateUI"
            resize="none"
          ></el-input>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col md="6" class="p-0">
          <div>
            <p class="bold mt-2" v-if="listTag.length == 0">
              <span class="bold" style="font-size: 14px">Đến:</span>
              <span style="color: #7e7e7e">
                "Vui lòng chọn ít nhất 1 người nhận"</span
              >
            </p>
            <b-row v-if="listTag.length > 0">
              <b-col md="1" class="p-0" style="margin-top: 7px">
                <span class="bold">Đến({{ listTag.length }}):</span>
              </b-col>
              <b-col md="11" class="pr-0">
                <el-tag
                  class="mb-2 mr-2"
                  :key="tag.id"
                  v-for="(tag, i) in listTag"
                  :disable-transitions="false"
                  :data-id="tag.id"
                  :title="`${
                    tag.name +
                    (tag.position_name ? ' (' + tag.position_name + ')' : '')
                  }`"
                >
                  <div
                    class="
                      d-flex
                      justify-content-between
                      align-items-center
                      h-100
                    "
                  >
                    <el-avatar
                      size="small"
                      :src="tag.avt ? tag.avt : 'img/Vector-person.png'"
                      class="ml-2 mr-2"
                    ></el-avatar>
                    <div class="d-flex align-items-center">
                      <p class="tag__name-overflow mr-1">{{ tag.name }}</p>
                      <p>
                        {{ tag.position_name ? `(${tag.position_name})` : "" }}
                      </p>
                    </div>
                    <i
                      class="el-tag__close el-icon-close"
                      @click="fn_closeTag(tag, i)"
                    ></i>
                  </div>
                </el-tag>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col md="6" class="pr-0">
          <h6 class="bold mb-3">3. Hiệu lực văn bản</h6>
          <b-row>
            <b-col md="6" class="pl-0">
              <el-date-picker
                class="datePicker"
                type="date"
                v-model="mData.dataForm.effected_date.start_effected_at"
                placeholder="Từ"
                format="dd/MM/yyyy"
                prefix-icon="isax-calendar-1"
                :clearable="false"
                :picker-options="pickerOptionFrom"
                @change="fn_checkValid"
                @input="forceUpdateUI"
              ></el-date-picker>
            </b-col>
            <b-col md="6" class="p-0">
              <el-date-picker
                class="datePicker"
                type="date"
                v-model="mData.dataForm.effected_date.end_effected_at"
                placeholder="Tới"
                format="dd/MM/yyyy"
                prefix-icon="isax-calendar-1"
                :clearable="false"
                :picker-options="pickerOptionFrom"
                @change="fn_checkValid"
                @input="forceUpdateUI"
              ></el-date-picker>
            </b-col>
          </b-row>
          <!-- Start Manipulate button -->
          <div class="text-right mt-3 pb-3 pr-0">
            <el-button class="btn__doc btn__doc-back" @click="fn_goBackPrevious"
              >Quay lại</el-button
            >
            <el-button
              v-if="viewMode == 'promulgate'"
              :disabled="listTag.length == 0 || !mData.dataForm.department_id"
              class="btn__doc btn__doc-transfer"
              @click="fn_submitForm('promulgate')"
              >{{ this.isDigitalSignature ? 'Ban hành (Ký số)' : 'Ban hành văn bản' }}
            </el-button>
          </div>
          <!-- End Manipulate button -->
        </b-col>
      </b-row>
    </div>
    <Loading v-if="loading" />
  </div>
</template>
<script>
import ExtensionService from "../../../service/ExtensionService";
import MethodService from "../../../service/MethodService";
import EmployeeApi from "../../../moduleApi/EmployeeApi";
import DocumentApi from "../../../moduleApi/DocumentApi";
import DepartmentApi from "../../../moduleApi/DepartmentApi";
import FileApi from "../../../moduleApi/FileApi";
import { dataDocMixins } from "../ElectronicDocument/DocumentMixins/dataDocMixins";
import { fnDocMixins } from "../ElectronicDocument/DocumentMixins/fnDocMixins";
import VueDocPreview from "vue-doc-preview";
import ViewPdf from "@/component/Draggable/ViewPdf";
import EmployeeSignatureApi from "@/moduleApi/EmployeeSignatureApi";
import Draggable from "@/component/Draggable/Draggable";
import Loading from "@/component/Loading";
import { Filter } from "mushroomjs";
import EventBus from "@/service/EventBus";
import SignatureDigitalService from "../../../service/SignatureDigitalService";

export default {
  mixins: [dataDocMixins, fnDocMixins],
  components: {
    VueDocPreview,
    ViewPdf,
    Draggable,
    Loading,
  },
  data() {
    return {
      ExtensionService,
      loading: false,
      fileId: "",
      url: "",
      activeProcess: 0,

      tabName: "",
      textFilter: "",
      listPeopleFilter: [],

      listTag: [],

      defaultProps: {
        children: "children",
        label: "label",
      },
      contentTransfer: "",

      drawerVisible: true,

      height: window.innerHeight - 218,
      imgSignId: undefined,
      listEmployeeSignatures: [],
      listDepaterments: [],
      fileUploadOption: {
        FileChuKy: {
          accept: ".png",
          dialogImageUrl: "",
          listImageSigns: [],
        },
      },
      pageNum: 1,
      pageSign: 0,
      numPages: 0,
      changedSignImage: true,
      historySign: {
        imageSignId: undefined,
        pageSigned: 0,
        positionX: 0,
        positionY: 0,
        width: 220,
        height: 220,
        page_index: 1
      },
      haveHistory: false,
      dataObject: {},
      employeeInfo: MethodService.getEmployeeInfo(),
      isDigitalSignature: false,
      pdfHeight: 0,
    };
  },

  watch: {
    textFilter(val) {
      if (this.tabName == "DonVi") this.$refs.organizationModelTree.filter(val);
      if (this.tabName == "Nhom") this.$refs.businessTree.filter(val);
    },
    dataObject(newVal, oldVal) {
      setTimeout(() => {
        if (this.dataObject.sign_image_id) {
          this.imgSignId = this.dataObject.sign_image_id;
          this.historySign = {
            imageSignId: this.dataObject.sign_image_id,
            pageSigned: this.dataObject.position.page_index,
            positionX: this.dataObject.position.x,
            positionY: this.dataObject.position.y,
            width: this.dataObject.position.width || 220,
            height: this.dataObject.position.height || 220,
          }
          this.checkHaveHistorySign()
          this.showChangeSignImage()
        }
      }, 1000)
    },
  },

  methods: {
    fn_checkManipulately(id, val, isFromDetail, note, data) {
      let elements = [];
      elements = document.querySelectorAll(`[data-id="${id}"]`);
      elements.forEach((e) => {
        e.checked = val;
        if (val) {
          $(e).closest(".el-card.card-item").addClass("checked");
        } else {
          $(e).closest(".el-card.card-item").removeClass("checked");
        }
      });
      if (!isFromDetail) {
        let objEmp = null;
        const employee = this.mData.dataDefault.listEmployee.find(
          (emp) => emp.id == id
        );
        if (employee) {
          let pos = null;
          if (employee.job_info.length > 0) {
            pos = this.mData.dataDefault.listPosition.find(
              (position) => position.id == employee.job_info[0].position_id
            );
          }
          objEmp = {
            id: id,
            value: val ? true : false,
            administrative_info: employee.administrative_info,
            job_info: employee.job_info,
            position_name: pos ? pos.name : "",
            employee_no: employee ? employee.employee_no : "---",
            avt: employee.image_id
              ? ExtensionService.urlImg + employee.image_id + "&r=square&w=512"
              : employee.administrative_info.avatar_id
              ? ExtensionService.urlImg +
                employee.administrative_info.avatar_id +
                "&r=square&w=512"
              : "",
          };
          this.fn_toggleTag(objEmp);
        }
      }
    },

    fn_checkValid() {
      if (
        this.mData.dataForm.effected_date.start_effected_at &&
        this.mData.dataForm.effected_date.end_effected_at
      ) {
        const startDate = new Date(
          new Date(
            this.mData.dataForm.effected_date.start_effected_at
          ).setHours(0, 0, 0)
        );
        const endDate = new Date(
          new Date(this.mData.dataForm.effected_date.end_effected_at).setHours(
            23,
            59,
            59
          )
        );
        if (startDate >= endDate) {
          this.$notify.info({
            message: "Mốc hết hiệu lực phải lớn hơn hoặc bằng mốc hiệu lực.",
            duration: 3000,
            customClass: "doc-info",
          });
          this.mData.dataForm.effected_date.end_effected_at = null;
        }
      }
    },

    fn_toggleDrawer() {
      this.drawerVisible = !this.drawerVisible;
    },

    changePage(pageNum) {
      this.pageNum = pageNum;
    },

    scrollToTop() {
      document.querySelector(".app-body").scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },

    changeSignImage(imageSignId) {
      if (imageSignId) {
        if (
          this.historySign.pageSigned &&
          this.historySign.pageSigned != this.pageNum
        ) {
          this.imgSignId = this.historySign.imageSignId;
          this.$notify.info({
            message: `Vui lòng xóa con dấu tổ chức ở trang cũ để chọn con dấu tổ chức mới.`,
            duration: 3000,
            customClass: "doc-info",
          });
          return;
        }
        this.changedSignImage = true;
        const img = new Image();
        img.src = ExtensionService.urlImg + imageSignId;
        setTimeout(() => {
          this.historySign.imageSignId = imageSignId;
          this.historySign.pageSigned = this.pageNum;
          this.historySign.positionX = 0;
          this.historySign.positionY = 0;
          this.historySign.width = img && img.width > 0 ? img.width : 220;
          this.historySign.height = img && img.height > 0 ? img.height : 160;

          this.dataObject.position = {
            x: this.historySign.positionX,
            y: this.historySign.positionY,
            width: this.historySign.width,
            height: this.historySign.height,
            page_index: this.historySign.pageSigned,
          }

          this.showChangeSignImage();
          this.scrollToTop();
          this.checkHaveHistorySign();
        }, 300);
      }
    },

    endDragSign(data) {
      this.historySign.imageSignId = data.imageSignId;
      this.historySign.pageSigned = data.pageSigned;
      this.historySign.positionX = data.positionX;
      this.historySign.positionY = data.positionY;
      this.historySign.width = data.width;
      this.historySign.height = data.height;
      this.checkHaveHistorySign();
    },

    showChangeSignImage() {
      setTimeout(() => {
        this.changedSignImage = false;
        setTimeout(() => {
          EventBus.$emit('changeImageIdEvent')
        }, 100)
      }, 300)
    },

    fn_deleteSignImage() {
      this.imgSignId = undefined;
      this.changedSignImage = true;
      this.haveHistory = false;
      this.historySign = {
        imageSignId: undefined,
        pageSigned: 0,
        positionX: 0,
        positionY: 0,
        width: 220,
        height: 220
      };
    },

    async fn_getEmployeeSignature() {
      this.fileUploadOption.FileChuKy.listImageSigns = [];
      const employeeSignatureApiRes = await EmployeeSignatureApi.list({
        filters: `employee_id=$$user_id`,
      });
      if (
        employeeSignatureApiRes.result &&
        employeeSignatureApiRes.result.length > 0
      ) {
        if (!employeeSignatureApiRes.result[0].image_ids) {
          employeeSignatureApiRes.result[0].image_ids = [];
        }
        this.listEmployeeSignatures = employeeSignatureApiRes.result[0];
      } else {
        this.listEmployeeSignatures = {
          employee_id: this.mData.currentUser.id,
          image_ids: [],
        };
      }
      (this.listEmployeeSignatures.image_ids || []).forEach((item) => {
        this.fileUploadOption.FileChuKy.listImageSigns.push({
          sign_image_id: item,
          url: ExtensionService.urlImg + item,
        });
      });
    },

    changePageNum(data) {
      this.pageNum = data.pageNum;
      this.numPages = data.numPages;
      this.scrollToTop();
    },

    checkHaveHistorySign() {
      this.haveHistory = false;
      if (this.historySign.imageSignId) {
        this.haveHistory = true;
      } else {
        this.haveHistory = false;
      }
    },

    // Seperate

    fn_filterNode(value, data) {
      if (!value) return true;
      return (
        data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
        (data.field_filter &&
          (data.field_filter.indexOf(value) !== -1 ||
            data.field_filter.indexOf(value.toLowerCase()) !== -1)) ||
        (data.parents_field &&
          (data.parents_field.indexOf(value) !== -1 ||
            data.parents_field.indexOf(value.toLowerCase()) !== -1)) ||
        (data.employee_no && data.employee_no.indexOf(value) !== -1) ||
        (data.email && data.email.indexOf(value) !== -1)
      );
    },

    fn_handleClickTab(tab, event) {
      this.tabName = tab.name;
      this.textFilter = "";
      if (this.tabName == "CaNhan")
        this.listPeopleFilter = this.listPeopleFilterRaw;
      else if (this.tabName == "DonVi")
        this.$refs.organizationModelTree.filter("");
      else if (this.tabName == "Nhom") this.$refs.businessTree.filter("");
      else if (this.tabName == "GanDay") {
        this.listNearestHistory = this.listPublishHistory.filter(
          (person) => person.administrative_info
        );
      }
    },

    async fn_getDataTabIndividual(isSearch) {
      const filter = Filter.and(
        Filter.eq("status", "DANG_LAM_VIEC"),
        Filter.ne("disabled", true),
        Filter.or(
          Filter.regex("employee_no", this.textFilter), // x:regex_i:ab[cd]
          Filter.regex("administrative_info.email", this.textFilter),
          Filter.regex(
            "administrative_info.name.full_name",
            this.textFilter,
            "i"
          )
        )
      ).build();
      const employeeApiRes = await EmployeeApi.list({
        limit: 5000,
        fields: "administrative_info,employee_no,job_info",
        filters: this.textFilter
          ? filter
          : "status=DANG_LAM_VIEC&disabled!=true",
      });
      if (employeeApiRes.result && employeeApiRes.result.length > 0) {
        this.listPeopleFilter = await this.fn_changeData(employeeApiRes.result);
        await this.fn_checkSignerFromTag();
        if (!isSearch) this.listPeopleFilterRaw = this.listPeopleFilter;
      } else {
        this.listPeopleFilter = [];
      }
    },

    fn_getDataTabNearest() {
      this.listNearestHistory = this.listPublishHistory.filter(
        (person) =>
          (person.name_filter &&
            person.name_filter.includes(this.textFilter.toLowerCase())) ||
          (person.employee_no &&
            person.employee_no.includes(this.textFilter)) ||
          (person.administrative_info &&
            person.administrative_info.name.full_name.includes(
              this.textFilter
            )) ||
          (person.administrative_info &&
            person.administrative_info.email.includes(this.textFilter))
      );
    },

    async fn_getListDataByTab(isSearch) {
      if (this.tabName == "CaNhan") {
        this.fn_getDataTabIndividual(isSearch);
      } else if (this.tabName == "GanDay") {
        this.fn_getDataTabNearest();
      }
    },

    fn_changeData(data) {
      data.forEach((e) => {
        e.job_info = MethodService.getValidJobInfo(e.job_info, this.mData.dataDefault.listContractTypeId);
        let pos = "";
        if (e.job_info.length > 0) {
          pos = this.mData.dataDefault.listPosition.find(
            (position) => position.id == e.job_info[0].position_id
          );
        }
        e.position_name = pos ? pos.name : "";
        const emp = this.mData.dataDefault.listEmployee.find(
          (emp) => emp.id == e.id
        );
        e.employee_no = emp ? emp.employee_no : "---";
        e.value = e.value == true ? e.value : false;
        e.avt =
          emp && emp.image_id
            ? ExtensionService.urlImg + emp.image_id + "&r=square&w=512"
            : emp &&
              emp.administrative_info &&
              emp.administrative_info.avatar_id
            ? ExtensionService.urlImg +
              emp.administrative_info.avatar_id +
              "&r=square&w=512"
            : "";
      });
      return data;
    },

    fn_checkSignerFromTag() {
      if (this.listTag.length > 0) {
        this.listPeopleFilter.forEach((person) => {
          this.listTag.forEach((tag) => {
            if (person.id == tag.id) {
              person.value = true;
            }
          });
        });
      }
    },

    fn_closeTag(tag) {
      // Toggle card at tab CaNhan
      this.listPeopleFilter.forEach((person) => {
        if (person.id == tag.id) {
          person.value = false;
          return;
        }
      });
      // Toggle card at tab GanDay
      this.listNearestHistory.forEach((person) => {
        if (person.receiver_id == tag.id) {
          person.value = false;
          return;
        }
      });
      // Toggle card at tab DonVi and Nhom
      this.fn_checkManipulately(tag.id, false, true);
      this.listTag.splice(this.listTag.indexOf(tag), 1);
    },

    fn_toggleTag(emp) {
      let isDuplicate = null;
      if (
        this.tabName == "CaNhan" ||
        this.tabName == "DonVi" ||
        this.tabName == "Nhom"
      ) {
        isDuplicate = this.listTag.find((e) => e.id == emp.id);
      } else if (this.tabName == "GanDay") {
        isDuplicate = this.listTag.find((e) => e.id == emp.receiver_id);
      }
      let pos = null;
      if (emp.job_info.length > 0) {
        pos = this.mData.dataDefault.listPosition.find(
          (position) => position.id == emp.job_info[0].position_id
        );
      }
      // Check person is exist in listTag to publish
      if (emp.value && !isDuplicate) {
        this.listTag.push({
          id:
            this.tabName == "CaNhan" ||
            this.tabName == "DonVi" ||
            this.tabName == "Nhom"
              ? emp.id
              : emp.receiver_id,
          name: emp.administrative_info.name.full_name,
          avt: emp.avt,
          job_info: emp.job_info,
          position_name: pos && pos.name ? pos.name : "",
        });
      } else if (!emp.value && isDuplicate) {
        // Toggle at listTag
        if (
          this.tabName == "CaNhan" ||
          this.tabName == "DonVi" ||
          this.tabName == "Nhom"
        ) {
          this.listTag = this.listTag.filter((tag) => tag.id != emp.id);
        } else if (this.tabName == "GanDay") {
          this.listTag = this.listTag.filter(
            (tag) => tag.id != emp.receiver_id
          );
        }
      }

      // Toggle at Tab manipulately
      this.fn_toggleCardForManipulatelyTab(emp);
    },

    fn_toggleCardForManipulatelyTab(emp) {
      if (this.tabName == "CaNhan") {
        this.fn_checkManipulately(emp.id, emp.value, true);
        this.listNearestHistory.forEach((person) => {
          if (person.receiver_id == emp.id) {
            person.value = !person.value;
            return;
          }
        });
      } else if (this.tabName == "GanDay") {
        this.fn_checkManipulately(emp.receiver_id, emp.value, true);
        this.listPeopleFilter.forEach((person) => {
          if (person.id == emp.receiver_id) {
            person.value = !person.value;
            return;
          }
        });
      } else if (this.tabName == "DonVi" || this.tabName == "Nhom") {
        // Tab CaNhan
        this.listPeopleFilter.forEach((person) => {
          if (person.id == emp.id) {
            person.value = !person.value;
            return;
          }
        });
        // Tab GanDay
        this.listNearestHistory.forEach((person) => {
          if (person.receiver_id == emp.id) {
            person.value = !person.value;
            return;
          }
        });
      }
    },

    getValidJobInfo() {
      let validJobInfo = MethodService.getValidJobInfo(
        this.employeeInfo.job_info, this.mData.dataDefault.listContractTypeId
      );
      //Nếu không có Job_info nào còn hiệu lực thì không lấy danh sách tất cả phòng ban
      if (!validJobInfo || validJobInfo.length == 0)
        this.getDepartermentByIds();
      let arrDepartmentIds = [];
      validJobInfo.forEach((jobInfo) => {
        if (jobInfo.department_id) {
          arrDepartmentIds.push(jobInfo.department_id);
        }
      });
      this.getDepartermentByIds(arrDepartmentIds);
    },

    async getDepartermentByIds(arrDepartmentIds) {
      let resApi;
      if (arrDepartmentIds) {
        resApi = await DepartmentApi.list({
          filters: `id:in:${arrDepartmentIds.join(",")}&disabled=false`,
          limit: arrDepartmentIds.length,
        });
        if (resApi.result.length == 0) {
          resApi = await DepartmentApi.list({
            filters: `disabled=false`,
            limit: 100,
          });
        }
      } else {
        resApi = await DepartmentApi.list({
          filters: `disabled=false`,
          limit: 100,
        });
      }
      if (resApi.result.length == 1)
        this.mData.dataForm.department_id = resApi.result[0].id;
      this.listDepaterments = resApi.result;
    },

    async fn_getDocById(id) {
      const documentInApiRes = await DocumentApi.findById(id);
      if (documentInApiRes.result) {
        this.mData.dataForm = documentInApiRes.result;
        this.fn_eventBus(
          this.checkTab(this.$route.query.type),
          "promulgate",
          this.mData.dataForm.name
        );
        // Init data
        if (!this.mData.dataForm.effected_date) {
          this.mData.dataForm.effected_date = {
            start_effected_at: null,
            end_effected_at: null,
            is_has_effected_after_signed: false,
          };
        }
        await this.fn_getMainFile();
        await this.fn_checkToSetFileId();

        if(this.mData.dataForm.signers.some(signer => signer.is_digital_signature === true)){
          this.isDigitalSignature = true;
        }
      }
    },

    async fn_getMainFile() {
      if (this.mData.dataForm.doc_file && this.mData.dataForm.doc_file.doc_id) {
        const listFile = await FileApi.list(
          {
            filters: `id=${this.mData.dataForm.doc_file.doc_id}`,
          },
          true
        );
        let data = [];
        if (listFile && listFile.result) {
          data = listFile.result;
          data.map((item) => {
            item.url = ExtensionService.getDocumentPreviewUrl(item.id);
          });
        }
        this.mData.fileUploadOption.fileMain.fileList = data;
      }
    },

    fn_checkToSetFileId() {
      let fileDetail = {};
      if (this.mData.dataForm.signed_doc_file_id) {
        this.url =
          ExtensionService.getDocumentPreviewUrl(
            this.mData.dataForm.signed_doc_file_id
          );
        this.fileId = this.mData.dataForm.signed_doc_file_id;
      } else if (
        this.mData.dataForm.doc_file &&
        this.mData.dataForm.doc_file.doc_id
      ) {
        fileDetail = this.mData.fileUploadOption.fileMain.fileList[0];
        this.url = ExtensionService.getDocumentPreviewUrl(fileDetail.id);
        this.fileId = fileDetail.id;
      }
    },

    async fn_submitForm(type) {
      try {
        let data = this.mData.dataForm;

        if (type == "next-to-promulgate") {
          this.viewMode = "promulgate";
          this.activeProcess = 1;
        } else if (type == "promulgate") {
          let fileIdSign = "";
          if (this.isDigitalSignature) {
            const notifyError = (mess) => {
              this.$notify.error({
                message: mess,
                duration: 3000,
                customClass: "doc-error",
              });
            };

            const pluginRes = await SignatureDigitalService.initPlugin();
            if (pluginRes.error) {
              notifyError(pluginRes.mess);
              return;
            }
            const session = pluginRes.session;

            const resCert = await SignatureDigitalService.getCert(session);

            console.log(resCert);
            if (resCert.error) {
              notifyError(resCert.mess);
              return;
            }
            const cert = resCert.cert;
            const pageIndex = this.historySign.pageSigned ; 
            const offsetX = this.pxToPt(this.historySign.positionX) || 0;
            const offsetYFromTop = this.pxToPt(this.historySign.positionY);
            const sigWidth = this.pxToPt(this.historySign.width) || this.pxToPt(150);
            const sigHeight = this.pxToPt(this.historySign.height) || this.pxToPt(150);
            const offsetY = this.pdfHeight - offsetYFromTop - sigHeight;
        
            // gửi cert + mã hash
            let hashDocumentToSignData ={
                File_id: this.fileId,
                Sign_image_id: this.imgSignId,
                CertChainBase64: cert,
                Position:{
                  X: offsetX,
                  Y: offsetY,
                  Width: sigWidth,
                  Height: sigHeight,
                  Page_Index: pageIndex,
                }
              };
            const resSign = await DocumentApi.HashDocumentToSign(hashDocumentToSignData);
            const { HashBase64, FileName } = resSign.result;
            // sign
            const hashSign = await SignatureDigitalService.signHash(
              SignatureDigitalService.base64ToHex(HashBase64).toUpperCase(),0,session
            );
            if(hashSign.error) {
              notifyError(hashSign.mess);
              return;
            }
            const body = {
                Signature: hashSign,
                FileName: FileName,
                FileImage: resSign.result.FileImage,
            };
            const res = await DocumentApi.InsertSignatrue(body);
              // const offsetX = this.pxToPt(this.dataObject.position.x ?? 0);
              // const offsetY = this.pxToPt( this.dataObject.position.y  ?? 0);
              if(res.result) {
                fileIdSign = res.result.FileId;
                this.url = ExtensionService.getDocumentPreviewUrl(this.fileId);
              } else {
                this.loading = false;
                this.$notify.warning({
                  message: "Ban hành văn bản bằng chữ ký điện tử thất bại.",
                  duration: 3000,
                  customClass: "doc-warning",
                });
                return;
              }
          }
          console.log("fileIdSign: ",fileIdSign);
          this.dataObject.sign_image_id = this.historySign.imageSignId;
          this.dataObject.position = {
            x: this.historySign.positionX,
            y: this.historySign.positionY,
            page_index: this.historySign.pageSigned,
          };
          const dataPublish = {
            id: data.id,
            content: this.contentTransfer,
            publisher_ids: this.listTag.map((tag) => tag.id),
            start_effected_at: this.mData.dataForm.effected_date
              .start_effected_at
              ? new Date(
                  new Date(
                    this.mData.dataForm.effected_date.start_effected_at
                  ).setHours(0, 0, 0)
                )
              : null,
            end_effected_at: this.mData.dataForm.effected_date.end_effected_at
              ? new Date(
                  new Date(
                    this.mData.dataForm.effected_date.end_effected_at
                  ).setHours(23, 59, 59)
                )
              : null,
            department_id: this.mData.dataForm.department_id,
            published_file_id: this.fileId, // File đã ban hành
            sign_image_id: this.dataObject.sign_image_id, // Ảnh chữ ký
            position: {
              x: this.fn_setX(),
              y: this.fn_setY(),
              width: this.historySign.width,
              height: this.historySign.height,
              page_index: this.dataObject.position.page_index,
            },
            docDigitalSignatureId : fileIdSign,
          };
          const res = await DocumentApi.PublishDocument(dataPublish);
          if (res.result) {
            await this.fn_checkStatus();
          }
        }
      } catch (error) {
        this.loading = false;
        this.$notify.warning({
          message: "Ban hành văn bản thất bại.",
          duration: 3000,
          customClass: "doc-warning",
        });
      }
    },

    fn_setX() {
      return this.dataObject.position.x >= 480 &&
        this.dataObject.position.x < 500 &&
        this.dataObject.position.y >= 960
        ? this.dataObject.position.x - 29
        : this.dataObject.position.x >= 540 && this.dataObject.position.y >= 920
        ? this.dataObject.position.x - 28
        : this.dataObject.position.x >= 580 && this.dataObject.position.y >= 500
        ? this.dataObject.position.x - 32
        : this.dataObject.position.x >= 440 && this.dataObject.position.y >= 80
        ? this.dataObject.position.x - 17
        : this.dataObject.position.x >= 360 && this.dataObject.position.y >= 860
        ? this.dataObject.position.x - 20
        : this.dataObject.position.x >= 270 && this.dataObject.position.y >= 870
        ? this.dataObject.position.x - 16
        : this.dataObject.position.x >= 280 && this.dataObject.position.y >= 80
        ? this.dataObject.position.x - 19
        : this.dataObject.position.x >= 600
        ? this.dataObject.position.x - 62
        : this.dataObject.position.x >= 500
        ? this.dataObject.position.x - 32
        : this.dataObject.position.x >= 300
        ? this.dataObject.position.x - 22
        : this.dataObject.position.x >= 50
        ? this.dataObject.position.x - 12
        : this.dataObject.position.x >= 30 && this.dataObject.position.y >= 70
        ? this.dataObject.position.x - 5
        : this.dataObject.position.x;
    },

    fn_setY() {
      return this.dataObject.position.x >= 250 &&
        this.dataObject.position.y >= 960
        ? this.dataObject.position.y - 50
        : this.dataObject.position.x >= 80 && this.dataObject.position.y >= 950
        ? this.dataObject.position.y - 48
        : this.dataObject.position.x >= 270 && this.dataObject.position.y >= 870
        ? this.dataObject.position.y - 46
        : this.dataObject.position.y >= 700
        ? this.dataObject.position.y - 42
        : this.dataObject.position.y >= 550 && this.dataObject.position.y >= 400
        ? this.dataObject.position.y - 32
        : this.dataObject.position.y >= 300
        ? this.dataObject.position.y - 22
        : this.dataObject.position.y >= 100
        ? this.dataObject.position.y - 14
        : this.dataObject.position.x >= 600 && this.dataObject.position.y >= 550
        ? this.dataObject.position.y - 18
        : this.dataObject.position.x >= 500 && this.dataObject.position.y <= 5
        ? this.dataObject.position.y
        : this.dataObject.position.y - 8;
    },

    async fn_checkStatus() {
      this.loading = true;
      const documentApiRes = await DocumentApi.findById(
        this.$route.params.id,
        true
      );
      if (
        documentApiRes.result &&
        documentApiRes.result.publish &&
        documentApiRes.result.publish.status == "PUBLISHED"
      ) {
        setTimeout(() => {
          this.loading = false;
          this.$notify.success({
            message: "Ban hành văn bản thành công.",
            duration: 3000,
            customClass: "doc-success",
          });
          this.fn_goBack();
        }, 1000);
      } else if (
        documentApiRes.result &&
        documentApiRes.result.publish &&
        documentApiRes.result.publish.status == "PUBLISHED_FAILED"
      ) {
        this.loading = false;
        this.$notify.warning({
          message: "Ban hành văn bản thất bại.",
          duration: 3000,
          customClass: "doc-warning",
        });
      } else {
        await this.fn_checkStatus();
      }
    },

    async fn_initData() {
      await Promise.all([
        this.fn_getListConTractType(),
        this.fn_getListPosition(),
        this.fn_getListEmployee()
      ]);
      await this.fn_getDocById(this.$route.params.id);
      await this.fn_getPublishHistory();
      await this.fn_getListDataByTab();
      await this.fn_getListOrganizationModelTreePromulgate();
      await this.fn_getListDocumentGroupTreePromulgate();
      if (this.mData.currentProfile.type == "COMPANY") {
        this.getListDepartermentByCompanyUser();
      } else {
        this.getValidJobInfo();
      }
      this.fn_getEmployeeSignature();
      this.fn_getCompanySign();
    },

    fn_goBackPrevious() {
      if (this.viewMode == "promulgate") {
        this.viewMode = "choose-seal";
        this.activeProcess = 0;
      } else if (this.viewMode == "choose-seal") {
        this.fn_goBack();
      }
    },

    handlePdfSize({ height }) {
      this.pdfHeight = height;
    },

    pxToPt(px) {
      return px * (72 / 96); 
    },

  },

  created() {
    this.fn_eventBus(this.checkTab(this.$route.query.type), "promulgate");
    this.viewMode = "choose-seal";
    this.tabName = "CaNhan";
    this.mData.dataForm.transfer = {
      content: "",
    };
    this.fn_initData();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tree__empty-block {
  display: none;
}
.section-1 {
  display: flex;
  align-items: center;
  height: 48px;
}
::v-deep .section-2 {
  align-items: center;
  justify-content: space-between;
  display: flex;
  margin-bottom: 5px;
  .issue-at {
    .issue-at--text {
      &::after {
        content: "*";
        color: #f56c6c;
        margin-left: 5px;
        font-weight: bold;
      }
    }
    .el-input__inner {
      padding-right: 30px;
    }
  }
}
::v-deep .body-pdf {
  position: relative;
}
::v-deep .empty__tab-text {
  color: #b3b3b3;
}
.drawer-container {
  .drawer {
    position: absolute;
    top: 0;
    right: 0;
    background: #d0d5d9;
    width: 25%;
    height: 100%;
    overflow: hidden;
    box-shadow: -3px 0px 2px 0px rgb(0 0 0 / 7%);
    z-index: 99;
  }
  .drawer-collapse {
    position: absolute;
    top: 0;
    right: 0;
    background: #292d32;
    width: 3%;
    height: 100%;
    overflow: auto;
    .drawer__header {
      flex-direction: column;
      background: #292d32;
      .drawer__header-title {
        background: #292d32;
        writing-mode: vertical-rl;
      }
    }
  }
  .drawer__header {
    background: #444242;
    padding: 15px 10px;
    .drawer__header-title {
      color: var(--white);
    }
  }
  .drawer__box {
    height: 50%;
    .drawer__box-title {
      padding: 10px 10px;
      background: #ababab;
      color: #292d32;
    }
    .drawer__box-content {
      padding: 10px;
      max-height: calc(100% - 92px);
      overflow: auto;
    }
  }
}

::v-deep .list-sign-image {
  width: 100%;
  padding: 0 10px;
  // max-height: 50%;
  overflow-y: auto;
  .radio-group {
    display: flex;
    flex-direction: column;
    .el-radio {
      position: relative;
      .el-radio__input {
        position: absolute;
        top: -3px;
        left: -15px;
        background-color: transparent;
        padding: 7px;
        border-radius: 50%;
        &.is-checked + .el-radio__label {
          color: #5e9bbc;
        }
        &.is-checked {
          .el-radio__inner {
            border-color: #5e9bbc;
            background: #fff;
          }
        }
        .el-radio__inner {
          width: 24px;
          height: 24px;
          border-color: #5e9bbc;
          &:hover {
            border-color: #5e9bbc;
          }
          &::after {
            width: 16px;
            height: 16px;
            background-color: #5e9bbc;
            border-color: #5e9bbc;
          }
        }
      }
    }
    .border-image {
      border: 1.5px solid #5e9bbc;
      border-radius: 2px;
      padding: 10px;
      text-align: center;
      // position: relative;
      .el-image {
        max-width: 300px;
      }
      .el-upload-dragger {
        max-width: 200px;
        height: 200px;
        border-radius: 50%;
        border-width: 2px;
        .el-upload__text {
          line-height: 20px;
        }
      }
    }
  }
}
::v-deep .border-image {
  border: 1.5px solid #5e9bbc;
  border-radius: 2px;
  padding: 10px;
  text-align: center;
  .el-image {
    max-width: 300px;
  }
  .el-upload-dragger {
    max-width: 200px;
    height: 200px;
    border-radius: 50%;
    border-width: 2px;
    .el-upload__text {
      line-height: 20px;
    }
  }
  .el-upload-list {
    display: none;
  }
}
::v-deep .pdf-content {
  width: 100%;
  overflow-y: auto;
}

::v-deep .dropzone {
  margin: 0 auto;
  p {
    color: var(--white);
  }
  .current-page {
    width: 50px !important;
    .el-input {
      .el-input__inner {
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  }
}
.pdf-container {
  position: relative;
  background: #444242;
  padding: 10px 0 5px;
  min-height: calc(100vh - 90px);
}
::v-deep .el-steps {
  font-family: "UTM Avo", "san-serif";
  .el-step__head {
    .el-step__icon {
      color: var(--white);
      background-color: #c1c5cc;
    }
    .el-step__line {
      left: 25px;
      right: 10px;
    }
  }
  .el-step__head.is-success,
  .el-step__head.is-process {
    .el-step__icon {
      border-radius: 50%;
      border-color: var(--turquoise);
      background-color: var(--turquoise);
      .el-step__icon-inner {
        color: var(--white);
      }
      .el-icon-check::before {
        content: "1";
        font-family: "UTM Avo", "san-serif";
        font-weight: 700;
        font-size: 13px;
        text-align: center;
        line-height: 1;
        color: var(--white);
      }
    }
  }
  .el-step__main {
    width: max-content;
    padding: 0 10px;
    background-color: #fffaf7;

    position: absolute;
    top: -8px;
    left: 25px;
    .el-step__title.is-success {
      font-weight: bold;
      color: var(--black);
    }
  }
}

::v-deep .theme--light.v-stepper {
  background: transparent;
  &:not(.v-sheet--outlined) {
    box-shadow: none;
  }
  .v-stepper__step {
    .v-stepper__step__step {
      font-weight: bold;
      background-color: var(--turquoise);
      margin-right: 5px;
    }
    .v-stepper__label {
      font-weight: bold;
    }
  }
}
::v-deep .main {
  .container-fluid {
    padding: 20px 20px 10px 25px;
  }
}

.preview__file-container {
  background: #bebebe;
  width: 100%;
  height: 100vh;
  box-shadow: 7px 7px 21px -7px rgb(0, 0, 0, 30%);
}
.checked {
  background: #d0e8f5 !important;
}
::v-deep .el-input__inner {
  border-radius: 0;
  box-shadow: none !important;
  border-radius: 5px !important;
}
::v-deep .el-checkbox {
  .el-checkbox__input.is-checked {
    .el-checkbox__inner {
      background-color: var(--turquoise);
      border-color: var(--turquoise);
    }
  }
  .el-checkbox__input.is-focus {
    .el-checkbox__inner {
      border-color: var(--turquoise) !important;
    }
  }
  .el-checkbox__input.is-indeterminate {
    .el-checkbox__inner {
      background-color: var(--turquoise);
      border-color: var(--turquoise);
    }
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border-color: var(--turquoise);
    top: 3px;
    &:hover {
      border-color: var(--turquoise) !important;
    }
    &:focus {
      border-color: var(--turquoise) !important;
    }
    &:active {
      border-color: var(--turquoise) !important;
    }
  }
}
::v-deep .el-textarea__inner {
  border-radius: 0;
  box-shadow: none !important;
  border-radius: 5px !important;
}
::v-deep .el-input__prefix {
  .el-input__icon.fa-search {
    margin-left: 7px;
  }
}

::v-deep .el-tabs__item {
  border-radius: 0;
  background-color: #e9e9e9;

  span {
    color: black;
  }
}
::v-deep .el-tabs__nav {
  &:not(.is-active)::after {
    content: "";
    position: absolute;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 2px;
    background: #d0d5d9;
  }
}

@media (min-width: 1366px) {
  ::v-deep .el-tabs__nav {
    width: 100%;
    .el-tabs__item {
      width: 25%;
    }
  }
}

::v-deep .el-tabs--border-card > .el-tabs__header {
  .el-tabs__item {
    font-size: 13px;
    border-top: 2px solid transparent;
    margin: 0;
    position: relative;

    &:not(:last-child)::before {
      content: "";
      position: absolute;
      top: 5px;
      right: -1px;
      width: 1px;
      height: 75%;
      background: #7e7e7e;
    }
  }

  .el-tabs__item.is-active {
    border-top: 2px solid var(--orange) !important;
    border-left: none;

    span {
      color: black;
      font-weight: bold;
    }

    &::after {
      content: "";
      position: absolute;
      bottom: -1px;
      right: 0px;
      width: 100%;
      height: 2px;
      background: #fff;
      z-index: 1000;
    }
  }
}
::v-deep .btn-default.dark-green {
  background: var(--dark-green) !important;
  border: 1px solid var(--dark-green) !important;

  &:focus {
    background: var(--dark-green) !important;
  }

  &:hover {
    background: #15c765 !important;
  }

  &:active {
    background: var(--dark-green) !important;
  }
}

::v-deep .btn-default.dark-blue {
  background: var(--dark-blue) !important;
  border: 1px solid var(--dark-blue) !important;

  &:focus {
    background: var(--dark-blue) !important;
  }

  &:hover {
    background: #438eff !important;
  }

  &:active {
    background: var(--dark-blue) !important;
  }
}

::v-deep .icon {
  cursor: pointer;
  font-size: 21px;
}
.el-icon-d-arrow-left,
.el-icon-d-arrow-right {
  font-size: 16px;
  background: #fff;
  border-radius: 1px;
}

::v-deep .isax-trash {
  color: var(--red);
}

::v-deep .isax-eye {
  color: var(--orange);
}

::v-deep .el-dialog__body {
  padding: 0px !important;
}

::v-deep .el-dialog__header {
  background-color: #fff !important;
  border-bottom: 1px solid #fff !important;
}

::v-deep .datePicker .el-input__prefix,
.el-input__suffix {
  right: 5px;
  left: auto;
}

::v-deep .el-input--suffix .el-input__inner {
  padding-left: 15px;
  padding-right: 15px;
}

::v-deep .el-tag {
  border: none;
  border-radius: 8px;
  background-color: #d0e8f5;
  .el-avatar--small {
    width: 23px;
    height: 23px;
    line-height: 28px;
  }
  .el-icon-close {
    color: var(--black);
    top: 0;
    &:hover {
      color: var(--white);
    }
  }
}
::v-deep .el-tag--small {
  height: 36px;
}

::v-deep .el-divider--horizontal {
  margin: 10px 0;
}
.empty-content {
  height: 500px;
  padding: 200px 0;
}
::v-deep .el-input__prefix {
  .el-input__icon.fa-search {
    margin-left: 7px;
  }
}

::v-deep .el-tabs--border-card > .el-tabs__header {
  .el-tabs__item {
    font-size: 13px;
    border-top: 2px solid transparent;
    margin: 0;
    position: relative;

    &:not(:last-child)::before {
      content: "";
      position: absolute;
      top: 5px;
      right: -1px;
      width: 1px;
      height: 75%;
      background: #7e7e7e;
    }
  }

  .el-tabs__item.is-activeProcess {
    border-top: 2px solid var(--orange) !important;
    border-left: none;
    // border-right: none;

    span {
      color: black;
      font-weight: bold;
    }

    &::after {
      content: "";
      position: absolute;
      bottom: -1px;
      right: 0px;
      width: 100%;
      height: 2px;
      background: #fff;
      z-index: 1000;
    }
  }
}
.icon-prefix,
.icon-suffix {
  font-size: 21px;
}
::v-deep .el-textarea__inner {
  height: calc(100vh - 395px);
}
::v-deep .el-tabs__content {
  overflow: auto;
  .el-tab-pane {
    height: calc(100vh - 525px);

    // overflow-y: scroll;
    .center-block {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

::v-deep .el-tabs__item {
  border-radius: 0;
  background-color: #e9e9e9;

  span {
    color: black;
  }
}
</style>

<style lang="scss">
.button-prev {
  border-radius: 5px;
  position: absolute;
  top: 50%;
  left: 5%;
  z-index: 98;
}
.button-next {
  border-radius: 5px;
  position: absolute;
  top: 50%;
  right: 5%;
  z-index: 98;
}
</style>
